import { useCallback, useEffect, useState } from 'react';

/**
 * Breite eines Elements, nachgeführt über ResizeObserver. Für Raster, die ihre Spalten aus der
 * tatsächlich verfügbaren Fläche rechnen – das Fenster lügt, sobald Ränder oder Leisten im Spiel
 * sind (FRONTEND_GUIDELINES §9). Vor der ersten Messung `null`.
 */
export function useElementWidth<T extends HTMLElement>() {
  const [element, setElement] = useState<T | null>(null);
  const [width, setWidth] = useState<number | null>(null);
  const ref = useCallback((node: T | null) => setElement(node), []);

  useEffect(() => {
    if (!element) return;
    const update = () => setWidth(element.clientWidth);
    update();
    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(update);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);

  return { ref, width };
}
